<template>
    <div>
        <section class="padding-vertical-content" v-if="modo == null">
            <div class="container">
                <div class="row">
                    <b-col md="6" sm="12" class="text-center p-3">
                        <button class="button large-button effect-button" @click="modo = 1">
                            <span>Seleccionar la misma butaca en todos los eventos</span>
                        </button>
                    </b-col>
                    <b-col md="6" sm="12" class="text-center p-3">
                        <button class="button large-button effect-button" @click="modo = 2">
                            <span>Seleccionar distintas butacas por evento</span>
                        </button>
                    </b-col>
                </div>
            </div>
        </section>

        <VentaMismaButaca 
            v-if="modo == 1" 
            :pack="pack"
        />
        <VentaDistintaButaca 
            v-if="modo == 2" 
            :pack="pack"
        />
    </div>
</template>

<script>
    import VentaDistintaButaca from './distinta_butaca/VentaDistintaButaca.vue';
    import VentaMismaButaca from './misma_butaca/VentaMismaButaca.vue';

    export default  {
        props: {
            pack: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                modo: null
            }
        },
        components: {
            VentaMismaButaca, VentaDistintaButaca
        }
    }
</script>